import { useState, useRef } from 'react';
import classnames from 'classnames';
import PerfectScrollbar from 'react-perfect-scrollbar';
// import { useGetBusinessQuery } from '@src/features/api/BusinessApi';
// import { useGetAccountInfoQuery } from '@src/features/api/AccountApi';
// import { useSelector } from 'react-redux';
// import { RootState } from '@src/app/store';
import VerticalMenuHeader from './VerticalMenuHeader';
import VerticalNavMenuItems from './VerticalNavMenuItems';

const Sidebar = (props: any) => {
  const {
    menuCollapsed,
    routerProps,
    menu,
    currentActiveItem,
    skin,
    menuData,
  } = props;

  const [groupOpen, setGroupOpen] = useState([]);
  const [groupActive, setGroupActive] = useState([]);
  const [currentActiveGroup, setCurrentActiveGroup] = useState([]);
  const [activeItem, setActiveItem] = useState(null);
  const [menuHover, setMenuHover] = useState(false);

  // const { tokenData } = useSelector((state: RootState) => state.auth);

  // const { data: account } = useGetAccountInfoQuery(tokenData!, {
  //   skip: !tokenData,
  // });

  // const { data: business } = useGetBusinessQuery(account?.businessId ?? '', {
  //   skip: !account?.businessId,
  // });

  const shadowRef = useRef<HTMLDivElement>(null);

  const onMouseEnter = () => {
    setMenuHover(true);
  };

  const scrollMenu = (container: any) => {
    if (shadowRef && container.scrollTop > 0) {
      if (!shadowRef.current?.classList.contains('d-block')) {
        shadowRef.current?.classList.add('d-block');
      }
    } else if (shadowRef.current?.classList.contains('d-block')) {
      shadowRef.current.classList.remove('d-block');
    }
  };

  return (
    <>
      <div
        className={classnames(
          'main-menu menu-fixed menu-accordion menu-shadow',
          {
            expanded: menuHover || menuCollapsed === false,
            'menu-light': skin !== 'semi-dark' && skin !== 'dark',
            'menu-dark': skin === 'semi-dark' || skin === 'dark',
          }
        )}
        onMouseEnter={onMouseEnter}
        onMouseLeave={() => setMenuHover(false)}
      >
        {menu || (
          <>
            <VerticalMenuHeader
              setGroupOpen={setGroupOpen}
              menuHover={menuHover}
              {...props}
            />
            {/* Vertical Menu Header Shadow */}
            <div className="shadow-bottom" ref={shadowRef} />

            <div className="navbar-logo d-flex align-items-center justify-content-center flex-column border-bottom pb-1">
              {/* {business?.logo && (
                <>
                  <div className="pt-1 my-25">
                    <img
                      className="brand-text rounded me-50"
                      src={business.logo}
                      alt="Placeholder"
                      height="200"
                      width="200"
                      style={{ border: 'solid 2px #ebe9f1' }}
                    />
                  </div>
                </>
              )} */}
            </div>

            {/* Perfect Scrollbar */}
            <PerfectScrollbar
              className="main-menu-content"
              options={{ wheelPropagation: false }}
              onScrollY={(container) => scrollMenu(container)}
            >
              <ul className="navigation navigation-main">
                <VerticalNavMenuItems
                  items={menuData}
                  menuData={menuData}
                  menuHover={menuHover}
                  groupOpen={groupOpen}
                  activeItem={activeItem}
                  groupActive={groupActive}
                  currentActiveGroup={currentActiveGroup}
                  routerProps={routerProps}
                  setGroupOpen={setGroupOpen}
                  menuCollapsed={menuCollapsed}
                  setActiveItem={setActiveItem}
                  setGroupActive={setGroupActive}
                  setCurrentActiveGroup={setCurrentActiveGroup}
                  currentActiveItem={currentActiveItem}
                />
              </ul>
            </PerfectScrollbar>
          </>
        )}
      </div>
    </>
  );
};

export default Sidebar;
